import fontResizer from "./common-components/fontResizer";
import pageLoader from "./common-components/pageLoader";
import landscapeOff from "./common-components/landscapeOff";
import stickyHeader from "./common-components/stickyHeader";
import svgConvert from "./common-components/svgConvert";
import navigationSlide from "./common-components/navigationSlide";
import navigationAccordion from "./common-components/navigationAccordion";
import animateObserver from "./common-components/animateObserver";
import lazyLoadImgObserver from "./common-components/lazyLoadImgObserver";
import clipPathImgObserver from "./common-components/clipPathImgObserver";
import desktopPanel from "./common-components/desktopPanel";
import footerAccordion from "./common-components/footerAccordion";



landscapeOff();
stickyHeader();
svgConvert();
// navigationSlide();
navigationAccordion();
animateObserver();
lazyLoadImgObserver();
clipPathImgObserver();
footerAccordion();
desktopPanel();


// -------------------- Above functions might be common for all website --------------------------

import homeHeroSlider from "./components/home/homeHeroSlider";
import leadershipSlider from "./components/home/leadership-slider";


homeHeroSlider();
leadershipSlider()
navigationSlide();
